webpackJsonp([32503283977284],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.MainSections = exports.AboutText = exports.IntroSection = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(7);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _BaseIntroSection = __webpack_require__(15);
	
	var _salary_ = __webpack_require__(407);
	
	var _salary_2 = _interopRequireDefault(_salary_);
	
	var _salary_3 = __webpack_require__(411);
	
	var _salary_4 = _interopRequireDefault(_salary_3);
	
	var _salary_5 = __webpack_require__(412);
	
	var _salary_6 = _interopRequireDefault(_salary_5);
	
	var _salary_7 = __webpack_require__(413);
	
	var _salary_8 = _interopRequireDefault(_salary_7);
	
	var _salary_9 = __webpack_require__(414);
	
	var _salary_10 = _interopRequireDefault(_salary_9);
	
	var _salary_11 = __webpack_require__(415);
	
	var _salary_12 = _interopRequireDefault(_salary_11);
	
	var _salary_13 = __webpack_require__(416);
	
	var _salary_14 = _interopRequireDefault(_salary_13);
	
	var _salary_15 = __webpack_require__(417);
	
	var _salary_16 = _interopRequireDefault(_salary_15);
	
	var _salary_17 = __webpack_require__(418);
	
	var _salary_18 = _interopRequireDefault(_salary_17);
	
	var _salary_19 = __webpack_require__(408);
	
	var _salary_20 = _interopRequireDefault(_salary_19);
	
	var _salary_21 = __webpack_require__(409);
	
	var _salary_22 = _interopRequireDefault(_salary_21);
	
	var _salary_23 = __webpack_require__(410);
	
	var _salary_24 = _interopRequireDefault(_salary_23);
	
	var _salary_25 = __webpack_require__(395);
	
	var _salary_26 = _interopRequireDefault(_salary_25);
	
	var _salary_27 = __webpack_require__(399);
	
	var _salary_28 = _interopRequireDefault(_salary_27);
	
	var _salary_29 = __webpack_require__(400);
	
	var _salary_30 = _interopRequireDefault(_salary_29);
	
	var _salary_31 = __webpack_require__(401);
	
	var _salary_32 = _interopRequireDefault(_salary_31);
	
	var _salary_33 = __webpack_require__(402);
	
	var _salary_34 = _interopRequireDefault(_salary_33);
	
	var _salary_35 = __webpack_require__(403);
	
	var _salary_36 = _interopRequireDefault(_salary_35);
	
	var _salary_37 = __webpack_require__(404);
	
	var _salary_38 = _interopRequireDefault(_salary_37);
	
	var _salary_39 = __webpack_require__(405);
	
	var _salary_40 = _interopRequireDefault(_salary_39);
	
	var _salary_41 = __webpack_require__(406);
	
	var _salary_42 = _interopRequireDefault(_salary_41);
	
	var _salary_43 = __webpack_require__(396);
	
	var _salary_44 = _interopRequireDefault(_salary_43);
	
	var _salary_45 = __webpack_require__(397);
	
	var _salary_46 = _interopRequireDefault(_salary_45);
	
	var _salary_47 = __webpack_require__(398);
	
	var _salary_48 = _interopRequireDefault(_salary_47);
	
	__webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntroSection = exports.IntroSection = function IntroSection() {
		return _react2.default.createElement(_BaseIntroSection.MainProjectIntroSection, { mainText: "LinkedIn Salary", subText: "Bringing salary transparency to help professionals understand their earning potential", mainImageSrc: _salary_2.default, mainImageSrc2x: _salary_26.default });
	};
	
	var ImageWithCaption = function ImageWithCaption(_ref) {
		var imgSrc = _ref.imgSrc,
		    imgSrc2x = _ref.imgSrc2x,
		    caption = _ref.caption;
		return [_react2.default.createElement("img", { className: "sectionImg border-radius-small", src: imgSrc, srcSet: imgSrc2x + " 2x", key: 1 }), _react2.default.createElement(
			"p",
			{ className: "font-size-small text-align-center caption desktop-max-width-small", key: 2 },
			caption
		)];
	};
	
	var AboutText = exports.AboutText = function AboutText() {
		return _react2.default.createElement(
			_Section2.default,
			{ className: "aboutText has-mobile-gutter" },
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "p-section" },
					_react2.default.createElement(
						"div",
						{ className: "font-size-med" },
						"ABOUT THE PRODUCT"
					),
					_react2.default.createElement(
						"p",
						{ className: "font-size-base font-family-open-sans line-height-large" },
						"One of the biggest pain points for working professionals is the lack of transparency on salary. LinkedIn Salary was meant to help both job seekers and working professionals get a better view on how much they should be paid.\xA0"
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "p-section pressRelease font-size-base font-family-open-sans line-height-large" },
					_react2.default.createElement(
						"span",
						{ className: "subHeading font-family-montserrat" },
						"Press Release:"
					),
					_react2.default.createElement(
						"span",
						{ className: "pressExample" },
						_react2.default.createElement(
							"a",
							{ href: "https://business.linkedin.com/talent-solutions/blog/product-updates/2017/introducing-linkedin-salary-insights" },
							"LinkedIn Blog:"
						),
						"Job Posts on LinkedIn will now feature Salary Insights"
					),
					_react2.default.createElement(
						"span",
						{ className: "pressExample" },
						_react2.default.createElement(
							"a",
							{ href: "https://techcrunch.com/2016/11/02/linkedin-plots-a-place-on-the-economic-graph-launches-salary-to-chart-what-we-earn/" },
							"Techcrunch:"
						),
						"Press release: LinkedIn plots a place on the economic graph, launches Salary to chart what we earn"
					),
					_react2.default.createElement(
						"span",
						{ className: "pressExample" },
						_react2.default.createElement(
							"a",
							{ href: "https://www.forbes.com/sites/kathleenchaykowski/2016/11/02/linkedin-debuts-its-salary-tool-taking-on-glassdoor-and-payscale" },
							"Forbes:"
						),
						"Meet LinkedIn's New Salary Calculator"
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "p-section" },
					_react2.default.createElement(
						"div",
						{ className: "font-size-med" },
						"MY ROLE"
					),
					_react2.default.createElement(
						"p",
						{ className: "font-size-base font-family-open-sans line-height-large" },
						"I was the lead designer for this project. I worked closely with my product counterpart and engineering team to come up with strategy, concept, wireframes, research and full visual designs for this product for desktop and mobile."
					)
				)
			)
		);
	};
	
	var Section1 = function Section1() {
		return _react2.default.createElement(
			_Section2.default,
			{ hasGreyBackground: true },
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "font-size-med line-height-med" },
					"STARTING WITH DATA COLLECTION"
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"Because this product is so data heavy, my first priority was collecting data from our members. We started emailing our most engaged users with popular titles, and slowly opened up to more and more titles asking basic salary stats such as base salary, additional compensation, and years of experience. In one year, we were able to collect 1 million data points across United States, Canada, and United Kingdom, and 2 years later, we\u2019re at over 3 million data points which gave us the ability to create a full on salary product."
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_4.default, imgSrc2x: _salary_28.default, caption: "Detailed collection flow with entry points and checkpoints." }),
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_6.default, imgSrc2x: _salary_30.default, caption: "Collection flow asking position, base salary, additional compensation, and years of experience." })
			)
		);
	};
	
	var Section2 = function Section2() {
		return _react2.default.createElement(
			_Section2.default,
			null,
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "font-size-med line-height-med" },
					"CREATING A LINKEDIN SALARY PRODUCT"
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"We knew that when we started this product, we would have a wide range of professionals who would be able to use this information. Students who would be looking for what career they should pursue, job seekers\xA0 would be looking into what jobs pay well, mid level career professionals would want to see if they're being paid fairly, and job posters would want to understand the landscape of where salary is for the roles they're posting. I sought out to design comprehensive insights for all our members."
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"We explored insights that we could potentially show our members, and how we can portray our data. We tested out different mocks with our members, and worked with our data science team and engineers to come up with the final set of data that we are actually able to build based on the data we\u2019ve collected."
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement("img", { className: "sectionImg border-radius-small", src: _salary_8.default, srcSet: _salary_32.default + " 2x" }),
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_10.default, imgSrc2x: _salary_34.default, caption: "Early explorations on data visualizations." }),
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_12.default, imgSrc2x: _salary_36.default, caption: "Final set of data for a company/title/region page." })
			)
		);
	};
	
	var Section3 = function Section3() {
		return _react2.default.createElement(
			_Section2.default,
			{ hasGreyBackground: true },
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "font-size-med line-height-med" },
					"RESEARCH TO FIND THE BALANCE BETWEEN USER NEEDS AND REVENUE"
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"Salary has and will be, for many, a sensitive topic, not only to job seekers and professionals, but also to recruiters and hiring managers. In order to understand how both sides would use and react to salary, we conducted research to understand the needs of users as well as the concerns coming from recruiters and hiring managers.\xA0We showed both job seekers and job posters salary on job pages to understand how they felt about seeing the data, which guided us in developing this product."
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-large font-color-red font-family-open-sans-italic line-height-xlarge" },
					"\"Salary is a reflection of the value I bring to a company. I want to make an impact. I want to help companies innovate and grow. Salary is a reflection of that. If the job doesn't pay much, then is my role really bringing a lot of value?\"",
					_react2.default.createElement("br", null),
					"- LinkedIn Job Seeker"
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_14.default, imgSrc2x: _salary_38.default, caption: "Variations of designs we tested with both job seekers and job posters." })
			),
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"We tested out a few variations to get reaction from job seeker and job posters to understand their reaction to seeing salary data on job postings. We learned that the more clear the title the better for both groups, making sure estimated and provided by employer was very important, and people perceived the histogram as more truthful, and as having data behind the numbers."
				)
			)
		);
	};
	
	var Section4 = function Section4() {
		return _react2.default.createElement(
			_Section2.default,
			null,
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "font-size-med line-height-med" },
					"FINDING A HAPPY MEDIUM BETWEEN JOB SEEKERS AND JOB POSTERS"
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"For recruiters and hiring managers, showing salary was a sensitive topic. I worked closely with our LinkedIn Recruiter team to understand concerns from their customers side.",
					_react2.default.createElement("br", null),
					"Rather than posting salary as base and total compensation, often times they'd consider ranges of salary for their prospective employees, which also gives employers some wiggle room in terms of final compensation. I worked with our Recruiter team designers to create a customized salary posting flow and made sure that the salary data that gets shown on the jobs detail page was very clear to our members whether it came from LinkedIn or from a job poster."
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-large font-color-red font-family-open-sans-italic line-height-xlarge" },
					"\"This [having salary info on a job post] is something that would be very beneficial for the employer and employee to ensure that there's a potential match\"",
					_react2.default.createElement("br", null),
					"- LinkedIn job poster"
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_16.default, imgSrc2x: _salary_40.default, caption: "In the job posting flow, job posters have the option of using LinkedIn provided data or provide their own." }),
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_18.default, imgSrc2x: _salary_42.default, caption: "In the final variation, we simplified the designs and made it clear to show estimated by LinkedIn vs provided by employers. We also show median salary for estimated vs ranges for provided by employer salaries." })
			)
		);
	};
	
	var Section5 = function Section5() {
		return _react2.default.createElement(
			_Section2.default,
			{ hasGreyBackground: true },
			_react2.default.createElement(
				"div",
				{ className: "has-mobile-gutter desktop-max-width-small" },
				_react2.default.createElement(
					"div",
					{ className: "font-size-med line-height-med" },
					"INTEGRATION WITHIN LINKEDIN ECOSYSTEM + NEXT STEPS"
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"Having a great set of data is awesome, but being able to apply it in context makes all the difference. Knowing that we now have a robust system, I worked closely with my Product Manager to strategize how we can integrate our powerful salary data into other LinkedIn products. I partnered closely with other teams across the company including the recruiter team, profile and notifications team, jobs page teams, as well as search team to ingrate salary data across their lines of product.\xA0 We also started partnering with Google Jobs and allowing them to pull from our data. Presenting valuable insights for our members when they needed it, would be the ultimate goal."
				),
				_react2.default.createElement(
					"p",
					{ className: "font-size-base line-height-large font-family-open-sans" },
					"Live product: ",
					_react2.default.createElement(
						"a",
						{ href: "https://www.linkedin.com/salary/", className: "font-color-red" },
						"linkedin.com/salary"
					)
				)
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_20.default, imgSrc2x: _salary_44.default, caption: "Integrating salary entry point on profile, and salary notifications in LInkedIn notifications." }),
				_react2.default.createElement(ImageWithCaption, { imgSrc: _salary_22.default, imgSrc2x: _salary_46.default, caption: "LInkedIn salary information being used in Google Jobs product." })
			)
		);
	};
	
	var Section6 = function Section6() {
		return _react2.default.createElement(
			_Section2.default,
			null,
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center has-mobile-gutter font-family-open-sans" },
				_react2.default.createElement("img", { className: "sectionImg border-radius-small", src: _salary_24.default, srcSet: _salary_48.default + " 2x" })
			)
		);
	};
	var MainSections = exports.MainSections = function MainSections() {
		return [_react2.default.createElement(Section1, { key: 1 }), _react2.default.createElement(Section2, { key: 2 }), _react2.default.createElement(Section3, { key: 3 }), _react2.default.createElement(Section4, { key: 4 }), _react2.default.createElement(Section5, { key: 5 }), _react2.default.createElement(Section6, { key: 6 })];
	};

/***/ }),

/***/ 292:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_1.061b9dbc.jpg";

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_10.b5196f49.jpg";

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_11.69813e6c.jpg";

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_12.4191fe16.jpg";

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_2.2725d662.jpg";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_3.f36fbdd7.jpg";

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_4.5ec4f789.jpg";

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_5.899fdb22.jpg";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_6.7019d16c.jpg";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_7.e501dd99.jpg";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_8.c9a0fc84.jpg";

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_9.2cde75d0.jpg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_1.99dcebb5.jpg";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_10.1ed44e1b.jpg";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_11.683f228e.jpg";

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_12.a5d5d778.jpg";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_2.196907b0.jpg";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_3.c34f6a50.jpg";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_4.9c2af13a.jpg";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_5.d745179c.jpg";

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_6.5287aa9c.jpg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_7.9be86110.jpg";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_8.b7450f58.jpg";

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salary_9.345f9e0f.jpg";

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BackToHomeHeader = __webpack_require__(14);
	
	var _BackToHomeHeader2 = _interopRequireDefault(_BackToHomeHeader);
	
	var _SalarySections = __webpack_require__(137);
	
	var _Footer = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SalaryPage = function SalaryPage() {
		return [_react2.default.createElement(_BackToHomeHeader2.default, { key: "header", title: "Salary", company: "LinkedIn" }), _react2.default.createElement(_SalarySections.IntroSection, { key: "intro" }), _react2.default.createElement(_SalarySections.AboutText, { key: "about" }), _react2.default.createElement(_SalarySections.MainSections, { key: "main" }), _react2.default.createElement(_Footer.NextProjectFooter, { key: "next", href: "/lookup" })];
	};
	
	exports.default = SalaryPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-salary-js-0202bf1e6742b2ad655d.js